<template>
  <div>
    <div class="home" v-if="checkMenuPermission('home')">
      <div class="col2 col-margin col2MinWidth">
        <div class="panel" v-loading="humanPeakLoading">
          <div class="header">
            <!-- 人流量统计 -->
            <div class="headRow title">人流量统计</div>
            <div class="headRow tabs">
              <label :class="{'active':trafficIndex === 2}" @click="trafficIndex = 2, getHumanPeakCurrent(2)">昨日</label>
              <!-- <label :class="{'active':trafficIndex === 1}" @click="trafficIndex = 2, getHumanPeakCurrent(1)">今日</label> -->
              <label :class="{'active':trafficIndex === 3}" @click="trafficIndex = 3, getHumanPeakCurrent(3)">本周</label>
              <label :class="{'active':trafficIndex === 4}" @click="trafficIndex = 4, getHumanPeakCurrent(4)">本月</label>
            </div>
            <div class="headRow" style="font-size: 14px; margin-left: 20px;" v-if="trafficIndex === 2">昨日通行量：{{countAll}}</div>
            <div class="headRow" style="font-size: 14px; margin-left: 20px;" v-if="trafficIndex === 3">本周通行量：{{countAll}}</div>
            <div class="headRow" style="font-size: 14px; margin-left: 20px;" v-if="trafficIndex === 4">本月通行量：{{countAll}}</div>
            <div class="headRow" style="margin-top: -10px;">
              <el-select clearable v-model="value" @change="getHumanPeakCurrent(trafficIndex)" placeholder="请添加位置" style="width: 150px; margin-left: 20px;">
                <el-option v-for="item in entranceArea" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </div>
          </div>
          <div v-show="!mainShow" ref="main" style="width: 100%;height: 220px; float: left"></div>
          <div class="map" v-show="mainShow">
            <div class="no-data" style="position: relative;top:0">
              <i class="fontFamily ryx-zanwushuju"></i>
              <br>亲，没找到你要的数据哦
            </div>
          </div>
        </div>
      </div>
      <div class="col2 col-padding col-margin col2MinWidth">
        <div class="panel" v-loading="doorTraDisLoading">
          <div class="header" style="padding-top: 10px;">
            <div class="headRow title1">人员概况</div>
            <!-- <div class="headRow tabs" style="width: calc(100% - 130px);"> -->
              <!-- <label :class="{'active':personnelIndex === 2}" @click="personnelIndex = 2, getNoPassEmpNum(2)">昨日</label> -->
              <!-- <label :class="{'active':personnelIndex === 1}" @click="personnelIndex = 2, getPassTypeCountDay(1)">今日</label> -->
              <!-- <label :class="{'active':personnelIndex === 3}" @click="personnelIndex = 3, getNoPassEmpNum(3)">本周</label> -->
              <!-- <label :class="{'active':personnelIndex === 4}" @click="personnelIndex = 4, getNoPassEmpNum(4)">本月</label> -->
            <!-- </div> -->
          </div>
          <div>
            <div v-show="!main3Show" style="width: 55%;height: 220px; float: left" ref="main3"></div>
            <div style="float: left; width: 50%;" class="map" v-show="main3Show">
              <div class="no-data" style="position: relative;top:0">
                <i class="fontFamily ryx-zanwushuju"></i>
                <br>亲，没找到你要的数据哦
              </div>
            </div>
            <div class="personnelContent" v-show="faceRegistration.authorizedCardsNumber != 0 || faceRegistration.faceRegistrationNumber != 0">
              <div class="title">业主注册情况</div>
              <div class="echartDecs">
                  <div class="item1">
                    <label class="label1" style="color: #4ca6ff;">{{faceRegistration.authorizedCardsNumber}}</label>
                    <br>
                    <label class="label2">卡授权数</label>
                  </div>
                  <div class="item2">
                    <label class="label1" style="color: #4ca6ff;">{{faceRegistration.authorizedCardsRate + '%'}}</label>
                    <br>
                    <label class="label">卡授权率</label>
                  </div>
                </div>
              <div style="width: 50px; height: 220px; float: left;" ref="main9"></div>
              <div class="echartDecs">
                  <div class="item1">
                    <label class="label1" style="color: #65d0a5;">{{faceRegistration.faceRegistrationNumber}}</label>
                    <br>
                    <label class="label2">人脸注册数</label>
                  </div>
                  <div class="item2">
                    <label class="label1" style="color: #65d0a5;">{{faceRegistration.faceRegistrationRate + '%'}}</label>
                    <br>
                    <label class="label">人脸注册率</label>
                  </div>
                </div>
                <div>
                </div>
            </div>
            <div v-show="faceRegistration.authorizedCardsNumber === 0 && faceRegistration.faceRegistrationNumber === 0"  style="float: left; width: 45%;">
              <div class="no-data" style="position: relative;top:0">
                <i class="fontFamily ryx-zanwushuju"></i>
                <br>亲，没找到你要的数据哦
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col2 col-margin">
        <div class="panel" v-loading="deviceOnlineLoading" style="overflow: auto;">
          <div class="header" style="padding-top: 10px;">
              <div class="headRow title">设备概况</div>
              <div class="headRow inputTab" style="width: 150px; float: right; margin-right: 60px;">
                <!-- :showedMaxLevel="2" -->
              <device-type-tree-input ref="deviceTypeTreeInput" v-model="search.deviceType"
                      @deviceTypeTreeShowed="deviceTypeTreeShowed"
                      @deviceTypeTreeHidden="deviceTypeTreeHidden"
                      @deviceTypeSelected="deviceTypeSelected"></device-type-tree-input>
              </div>
            </div>
          <div style="clear: both; margin-top: 50px;" v-show="!mainShow1">
            <div class="col1 equipment1">
              <div class="number">{{deviceOnlines.deviceTotal}}</div>
              <div>设备总数</div>
            </div>
            <div class="col1 equipment2">
              <div class="number">{{deviceOnlines.checkTotal}}</div>
              <div>检测总数</div>
            </div>
            <div class="col1 equipment3">
              <div class="number">{{deviceOnlines.onlineDevice}}</div>
              <div>在线设备</div>
            </div>
            <div class="col1 equipment4">
              <div class="number">{{deviceOnlines.offlineDevice}}</div>
              <div>离线设备</div>
            </div>
            <div class="col1 equipment5">
              <div class="number" v-if="deviceOnlines.onlineRate === 0 || !deviceOnlines.onlineRate">0%</div>
              <div class="number" v-else>{{deviceOnlines.onlineRate}}</div>
              <div>在线率</div>
            </div>
          <!-- </div> -->
          <!--  -->
            <div style="clear: both; height: 110px; text-align: center" v-if="deviceOnlines.averageOfflineTimes !== 0 || deviceOnlines.averageOfflineTotal !== '00:00:00' ||deviceOnlines.latestVersionNumber !== 0">
              <div class="col1" style="margin-left: 100px;margin-right: 100px;">
                <div class="number" style="color: #ea6a6a;">{{deviceOnlines.averageOfflineTimes}}</div>
                <div>平均离线次数/日</div>
              </div>
              <div class="col1" style="margin-right: 100px;">
                <div class="number" style="color: #ea6a6a;">{{deviceOnlines.averageOfflineTotal}}</div>
                <div>平均离线时长</div>
              </div>
              <div class="col1" style="margin-right: 100px;">
                <div class="number" style="color: #ea6a6a;">{{deviceOnlines.latestVersionNumber}}</div>
                <div>最新设备版本号</div>
              </div>
            </div>
          </div>
          <div class="map" v-show="mainShow1">
            <div class="no-data" style="top: 50px">
              <i class="fontFamily ryx-zanwushuju"></i>
              <br>亲，没找到你要的数据哦
            </div>
          </div>
        </div>
      </div>
      <div class="col2 col-margin">
        <div class="panel" v-loading="passTypeLoading">
            <div class="header" style="padding-top: 10px;">
              <div class="headRow title1">通行方式统计</div>
              <div class="headRow tabs" style="width: calc(100% - 130px);">
                <label :class="{'active':passTypeIndex === 2}" @click="passTypeIndex = 2, getPassTypeCountDay(2)">昨日</label>
                <!-- <label :class="{'active':passTypeIndex === 1}" @click="passTypeIndex = 2, getPassTypeCountDay(1)">今日</label> -->
                <label :class="{'active':passTypeIndex === 3}" @click="passTypeIndex = 3, getPassTypeCountDay(3)">本周</label>
                <label :class="{'active':passTypeIndex === 4}" @click="passTypeIndex = 4, getPassTypeCountDay(4)">本月</label>
              </div>
            </div>
            <div v-show="!main2Show" style="width: 100%;height: 253px" ref="main2"></div>
            <div class="map" v-show="main2Show">
              <div class="no-data" style="position: relative;top:0">
                <i class="fontFamily ryx-zanwushuju"></i>
                <br>亲，没找到你要的数据哦
              </div>
            </div>
          </div>
      </div>
      <div style="height: 340px; border-radius:8px" class="col4 col-margin">
      <div class="panel table">
         <!-- v-if="alarmShow" -->
        <div style="height: calc(100% - 20px);" class="col2 col-margin">
          <div class="panel" v-loading="countAlarmLoading">
            <div class="header" style="padding-top: 0;">
              <div class="headRow title">告警概况</div>
              <div class="headRow total">总告警数： {{countAlarmSurveyList.alarmNumber}}</div>
              <div class="headRow tabs">
                <label :class="{'active':AlarmSurveyIndex === 2}" @click="AlarmSurveyIndex = 2, getCountAlarmLevel(2)">昨日</label>
                <!-- <label :class="{'active':AlarmSurveyIndex === 1}" @click="AlarmSurveyIndex = 2, getCountAlarmLevel(1)">今日</label> -->
                <label :class="{'active':AlarmSurveyIndex === 3}" @click="AlarmSurveyIndex = 3, getCountAlarmLevel(3)">本周</label>
                <label :class="{'active':AlarmSurveyIndex === 4}" @click="AlarmSurveyIndex = 4, getCountAlarmLevel(4)">本月</label>
              </div>
            </div>
            <div v-show="countAlarmSurveyList.alarmNumber !== 0" class="echartContent">
              <div class="echartDiv">
                <div class="echartPie" ref="main4"></div>
                <div class="echartDec">
                  <div class="item1">
                    <label class="label1">{{countAlarmSurveyList.highAlarm}}</label>
                    <br>
                    <label class="label2">告警（次）</label>
                  </div>
                  <div class="item2">
                    <label class="label1">{{countAlarmSurveyList.resolvedHigh}}</label>
                    <br>
                    <label class="label">已解决（次）</label>
                  </div>
                </div>
              </div>
              <div class="echartDiv">
                <div class="echartPie" ref="main5"></div>
                <div class="echartDec">
                  <div class="item1">
                    <label class="label1">{{countAlarmSurveyList.middleAlarm}}</label>
                    <br>
                    <label class="label2">告警（次）</label>
                  </div>
                  <div class="item2">
                    <label class="label2">{{countAlarmSurveyList.resolvedMiddle}}</label>
                    <br>
                    <label class="label">已解决（次）</label>
                  </div>
                </div>
              </div>
              <div class="echartDiv">
                <div class="echartPie" ref="main6"></div>
                <div class="echartDec">
                  <div class="item1">
                    <label class="label1">{{countAlarmSurveyList.lowestAlarm}}</label>
                    <br>
                    <label class="label2">告警（次）</label>
                  </div>
                  <div class="item2">
                    <label class="label3">{{countAlarmSurveyList.resolvedLowest}}</label>
                    <br>
                    <label class="label">已解决（次）</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="map" style="height: 260px;" v-show="countAlarmSurveyList.alarmNumber === 0">
              <div class="no-data">
                <i class="fontFamily ryx-zanwushuju"></i>
                <br>亲，没找到你要的数据哦
              </div>
            </div>
          </div>
        </div>
        <div v-if="alarmShow" style="height: calc(100% - 20px);" class="col2 col-margin">
          <closePopup ref="closePopup" @onClose="closeEvent"></closePopup>
          <div v-show="!main7Show" style="width: 100%;height: 0" ref="main7"></div>
          <div class="panel table">
            <el-table stripe :data="tableData" :row-style="{height: '39px'}" :cell-style="{padding: '0'}" height="100%" v-loading="searchListLoading" style="width: 100%;border-radius:8px">
              <el-table-column prop="alarmTime" header-align="center" align="center" label="时间" width="140">
                <template slot-scope="scope">
                  <span style="text-align: center">{{scope.row.alarmTime|formatDate}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="alarmName" header-align="center" align="center" label="名称" width="100"></el-table-column>
              <el-table-column prop="signalTypeName" header-align="center" align="center" label="产品类别" width="100"></el-table-column>
              <el-table-column header-align="center" label="描述">
                <template slot-scope="scope">
                  <template v-if="scope.row.alarmInfo.length<68">{{scope.row.alarmInfo}}</template>
                  <template v-else>
                    <el-tooltip class="item" effect="dark" :content="scope.row.alarmInfo" placement="top">
                      <span>{{scope.row.alarmInfo.substring(0,68)+'...'}}</span>
                    </el-tooltip>
                  </template>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="alarmInfo" header-align="center" align="center" label="描述"></el-table-column> -->
              <el-table-column prop="alarmLevelName" header-align="center" align="center" label="等级" width="80"></el-table-column>
              <!-- <el-table-column header-align="center" align="center" width="80" label="等级">
                <template slot-scope="scope">
                  <span :class="scope.row.alarmLevelName === '高' ? 'danger' : (scope.row.alarmLevelName === '中'?'warning':'success')" disable-transitions>
                    {{scope.row.alarmLevelName}}
                  </span>
                </template>
              </el-table-column> -->
              <!-- <el-table-column header-align="center" align="center" width="90" label="操作">
                <template slot-scope="scope">
                  <el-button type="text" @click="closeItem(scope.row,scope.$index)">关闭</el-button>
                </template>
              </el-table-column> -->
            </el-table>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import closePopup from './dataSearch/common/closeAlarm.vue'
import dateFormat from '../utils/Tools/index' // 引入时间格式化工具
import DeviceTypeTreeInput from '@/components/deviceTypeTreeHome'
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/markPoint')
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/radar')
require('echarts/lib/chart/pie')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legendScroll')
var bluetooth = require('../assets/images/home/bluetooth.png')
var qrCode = require('../assets/images/home/qrCode.png')
var face = require('../assets/images/home/face.png')
var call = require('../assets/images/home/call.png')
var remote = require('../assets/images/home/remote.png')
var IC = require('../assets/images/home/IC.png')
// var picArray = [IC, qrCode, face, bluetooth, remote, call]
var picArray = []
var picArrays = {10: IC, 20: qrCode, 30: face, 40: bluetooth, 50: remote, 60: call}
const passType = {10: '刷卡', 20: '二维码', 30: '人脸', 40: '蓝牙', 50: '远程', 60: '呼叫中心'}
const passTypeColor = {10: '#9fd82e', 20: '#9E77ED', 30: '#ea6a6a', 40: '#4ca6ff', 50: '#ffc34a', 60: '#50ca98'}
let interval = ''
let tipFormatter = '{a} <br/>{b}: {c} ({d}%)'
export default {
  data () {
    return {
      month: 0,
      mainShow: true,
      mainShow1: true,
      main2Show: true,
      main3Show: true,
      main7Show: true,
      passTypeIndex: 2,
      personnelIndex: 2,
      AlarmSurveyIndex: 2,
      trafficIndex: 2,
      entranceArea: [],
      deviceOnlines: {
        averageOfflineTimes: 0,
        averageOfflineTotal: '00:00:00',
        latestVersionNumber: 0
      },
      alarmShow: true,
      tableData: [],
      input: '',
      closeId: '',
      humanPeakLoading: false,
      passTypeLoading: false,
      doorTraDisLoading: false,
      searchListLoading: false,
      countAlarmLoading: false,
      deviceOnlineLoading: false,
      // projectFaceLoading: false,
      countAlarmSurveyList: [], // 告警数据
      countAll: 0,
      countAlarm: false,
      faceRegistration: {
        authorizedCardsNumber: 0,
        faceRegistrationNumber: 0
      },
      tipName: '',
      search: {
        deviceType: null
      },
      value: ''
    }
  },
  components: {
    closePopup,
    DeviceTypeTreeInput
  },
  filters: {
    // 日期格式化为 yyyy-MM-dd hh:mm
    formatDate (time) {
      let date = new Date(time)
      return dateFormat.dateFormat(date, 'yyyy-MM-dd hh:mm:ss')
    }
  },
  computed: {
    selectedProjectId () {
      return this.$store.getters.user.selectedProject ? this.$store.getters.user.selectedProject.id : null
    }
  },
  mounted () {
    if (!this.selectedProjectId) {
      return
    }
    this.getHumanPeakCurrent()
    this.getNoPassEmpNum()
    this.getCountAlarmLevel()
    this.deviceOnline()
    this.getPassTypeCountDay()
    this.getSearchList()
    this.getOutdoor()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy () {
    window.removeEventListener('reisze', this.resize)
  },
  methods: {
    resize () {
      //  this.$refs.main4, this.$refs.main5, this.$refs.main6,
      const domList = [this.$refs.main, this.$refs.main2, this.$refs.main3, this.$refs.main7, this.$refs.main9]
      let myChart
      domList.forEach(o => {
        myChart = echarts.init(o)
        myChart.resize()
      })
    },
    deviceTypeTreeShowed () {
      this.$refs.deviceTypeTreeInput.treeFilter('')
    },
    deviceTypeTreeHidden () {
      // this.search.deviceType = this.search.deviceType
      // this.deviceOnline()
      // this.$refs.deviceTypeTreeInput.hideDeviceTypeTree()
    },
    deviceTypeSelected (val) {
      if (val.name === '全部') {
        this.search.deviceType = ''
        this.deviceOnline()
        this.$refs.deviceTypeTreeInput.hideDeviceTypeTree()
      }
      if (!val.children) {
        this.search.deviceType = val.name
        this.getDeviceOverview(this.search.deviceType)
        this.$refs.deviceTypeTreeInput.hideDeviceTypeTree()
      }
    },
    /**
     * @Description:获取在线设备数据
     * @param null
     * @return null
     */
    async getDeviceOnline () {
      if (!this.selectedProjectId) {
        return false
      }
      return this.$https.post('console/deviceOverview', {projectId: this.selectedProjectId, typeName: ''}, false)
    },
    async getDeviceOverview (typeName) {
      if (!this.selectedProjectId) {
        return false
      }
      const data = await this.$https.post('console/deviceOverview', {projectId: this.selectedProjectId, typeName: typeName}, false)
      if (data.code === 'RESP1000') {
        if (typeName !== '') {
          this.mainShow1 = true
          // this.$message('没有查询到' + typeName + '的设备概况')
          // this.search.deviceType = ''
        }
      } else {
        this.mainShow1 = false
        if (typeof data.data.averageOfflineTimes === 'undefined' || !data.data.averageOfflineTimes) {
          data.data.averageOfflineTimes = 0
        }
        if (typeof data.data.averageOfflineTotal === 'undefined' || !data.data.averageOfflineTotal) {
          data.data.averageOfflineTotal = '00:00:00'
        }
        if (typeof data.data.latestVersionNumber === 'undefined' || !data.data.latestVersionNumber) {
          data.data.latestVersionNumber = 0
        }
        this.deviceOnlines = data.data
      }
    },
    getOutdoor () {
      if (!this.selectedProjectId) {
        return false
      }
      let _self = this
      this.$https.get('console/outDoor?projectId=' + this.selectedProjectId, {
        // projectId: this.selectedProjectId
      }, false).then(({code, data, msg}) => {
        if (code === '0') {
          _self.entranceArea = data
        } else {
          this.$message({
            type: 'error',
            message: msg,
            showClose: true
          })
        }
      })
    },
    async closeEvent (data) {
      this.$refs.closePopup.startLoading()// 按钮开始loading
      try {
        const responseData = await this.$https.axios({
          method: 'post',
          url: 'console/alarmDetailsClose',
          data: {
            id: this.closeId,
            remark: data.remarks,
            jobNoId: data.jobOrder
          }
        })
        if (responseData.code === 'RESP0000' || responseData.code === '0' || responseData.code === 0) {
          this.getSearchList()
          this.$refs.closePopup.hide()
          this.$message({
            message: '关闭成功',
            type: 'success',
            showClose: true
          })
        }
        this.$refs.closePopup.endLoading()// 按钮loading结束
      } catch (e) {
        this.$refs.closePopup.endLoading()
        // 处理错误
        console.log(e)
      }
    },
    closeItem (row, index) {
      this.closeId = row.id
      this.$refs.closePopup.show()
    },

    /**
       * @Description:获取今日流量统计数据
       * @param {Object} {date：日期}
       * @return null
       */
    humanPeakCurrentDay (passTimeType) {
      if (!this.selectedProjectId) {
        return false
      }
      this.humanPeakLoading = true
      return this.$https.post('console/trafficStatistics', {
        projectId: this.selectedProjectId,
        passTimeType: passTimeType,
        entranceArea: this.value
        // date
      }, false).then(({code, data, msg}) => {
        this.humanPeakLoading = false
        if (code === '0') {
          return data
        } else {
          this.$message({
            type: 'error',
            message: msg,
            showClose: true
          })
        }
      }, () => {
        this.humanPeakLoading = false
      })
    },
    /**
       * @Description:今日流量统计echart渲染
       * @param data {Array} 统计数据
       * @return null
       */
    humanPeakEcharts (data) {
      let xData = data.map(item => item.passTime)
      let yData = data.map(item => item.passCount)
      this.countAll = 0
      yData.map(item => {
        this.countAll += parseInt(item)
      })
      // let nowDate = ''
      // if (this.trafficIndex === 2) {
      //   nowDate = new Date()
      //   nowDate = dateFormat.dateFormat(nowDate.setDate(nowDate.getDate() - 1), 'yyyy-MM-dd')
      // } else if (this.trafficIndex === 3) {
      //   nowDate = '本周'
      // } else if (this.trafficIndex === 3) {
      //   nowDate = '本月'
      // } else {
      //   nowDate = dateFormat.dateFormat(Date.now(), 'MM-dd')
      // }
      let weeks = ''
      let month = ''
      let xAsis = {}
      if (this.trafficIndex === 2) {
        weeks = ': 00'
      }
      if (this.trafficIndex === 4) {
        var myDate = new Date()
        month = myDate.getMonth() + 1 + '-'
        xAsis = {
          axisLabel: {interval: 1},
          splitLine: {
            show: false,
            lineStyle: {color: '#E7ECF1'}
          },
          axisLine: {
            lineStyle: {color: '#fff', show: false} // x轴坐标轴颜色
          },
          axisTick: {
            show: false
          },
          type: 'category',
          boundaryGap: false,
          data: xData
        }
      } else {
        xAsis = {
          axisLabel: {interval: 0},
          splitLine: {
            show: false,
            lineStyle: {color: '#E7ECF1'}
          },
          axisLine: {
            lineStyle: {color: '#fff', show: false} // x轴坐标轴颜色
          },
          axisTick: {
            show: false
          },
          type: 'category',
          boundaryGap: false,
          data: xData
        }
      }
      let option = {
        textStyle: {
          color: '#8CA0B9'
        },
        tooltip: {
          trigger: 'axis',
          formatter: `${month}{b} ${weeks}<br />{c0}人`
          // formatter: '{b0}: {c0}<br />{b1}: {c1}' ${nowDate}
        },
        grid: {
          left: '8%',
          right: '4%',
          top: '13%',
          bottom: '10%'
        },
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0,
            // color: 'rgba(8, 232, 204, 0.36)' // 0% 处的颜色
            color: 'rgba(74, 146, 224, 0.3)'
          }, {
            offset: 1,
            // color: 'rgba(8, 232, 204, 0)' // 100% 处的颜色
            color: 'rgba(74, 146, 224, 0)' // 100% 处的颜色
          }],
          global: false // 缺省为 false
        },
        xAxis: xAsis,
        yAxis: {
          axisLine: {
            lineStyle: {color: '#fff'} // x轴坐标轴颜色
          },
          splitLine: {
            show: true,
            lineStyle: {color: '#E7ECF1'}
          },
          axisTick: {
            show: false
          },
          type: 'value',
          boundaryGap: [0, '30%']
        },
        series: [
          {
            type: 'line',
            smooth: 0.5,
            symbol: 'none',
            lineStyle: {
              // color: '#30BEAC',
              color: '#4A92E0',
              width: 1.5
            },
            areaStyle: {},
            data: yData
          }
        ]
      }
      this.$nextTick(() => {
        echarts.init(this.$refs.main).setOption(option)
      })
    },
    /**
       * @Description:今日流量统计
       * @param null
       * @return null
       */
    getHumanPeakCurrent (passTimeType) {
      if (typeof passTimeType === 'undefined') {
        passTimeType = 2
      }
      return this.humanPeakCurrentDay(passTimeType).then(data => {
        // if (data !== null && typeof data === 'object') {
        if (data !== null && Array.isArray(data) && data.length > 0) {
          this.mainShow = false
          this.humanPeakEcharts(data)
        } else {
          this.mainShow = true
        }
      })
    },

    /**
       * @Description:获取通行方式数据
       * @param  {Object} {startTime:开始时间，endTime：结束时间}
       * @return null
       */
    passTypeCountDay (passTimeType) {
      if (!this.selectedProjectId) {
        return false
      }
      this.passTypeLoading = true
      return this.$https.post('console/trafficMode', {
        projectId: this.selectedProjectId,
        passTimeType: passTimeType
      }, false).then(({code, data, msg}) => {
        this.passTypeLoading = false
        if (code === '0') {
          return data
        } else {
          this.$message({
            type: 'error',
            message: msg,
            showClose: true
          })
        }
      }, () => {
        this.passTypeLoading = false
      })
    },
    /**
       * @Description:通行方式echart渲染
       * @param data {Array} 通行方式数据
       * @return null
       */
    passTypeCountDayEcharts (data, coloList) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].value > 0) {
          data[i].label = {
            show: true,
            alignTo: 'edge',
            position: 'outer',
            formatter: '{pic|}{name|{c}次}\n{time|{b}}',
            margin: '20%',
            lineHeight: 12,
            align: 'left',
            rich: {
              pic: {
                backgroundColor: {
                  image: picArray[i]
                },
                width: 30,
                height: 30
              },
              name: {
                fontSize: 14
              },
              time: {
                fontSize: 12,
                color: '#666666',
                padding: [0, 0, 0, 30]
              }
            }
          }
          data[i].labelLine = {
            show: true,
            length: 30,
            length2: 100,
            maxSurfaceAngle: 80
            // minTurnAngle: 90
          }
        } else {
          data[i].label = {
            show: false
          }
          data[i].labelLine = {
            show: false
          }
        }
      }
      let option = { itemStyle: {
        borderWidth: 2,
        borderColor: '#fff'
      }}
      if (data.length === 1) {
        option.itemStyle.borderWidth = 0
      }
      option = {
        tooltip: {
          trigger: 'item',
          formatter: tipFormatter
        },
        series: [
          {
            startAngle: 140, // 起始角度
            ...option,
            name: '通行方式',
            type: 'pie',
            radius: ['55%', '70%'],
            center: ['50%', '55%'],
            color: coloList,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            labelLayout: function (params) {
              let myChart = echarts.init(this.$refs.main2)
              var isLeft = params.labelRect.x < myChart.getWidth() / 2
              var points = params.labelLinePoints
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width
              return {
                labelLinePoints: points
              }
            },
            data
          }
        ]
      }
      this.$nextTick(() => {
        echarts.init(this.$refs.main2).setOption(option)
      })
    },
    /**
       * @Description:今日通行方式
       * @param null
       * @return null
       */
    getPassTypeCountDay (passTimeType) {
      if (typeof passTimeType === 'undefined') {
        passTimeType = 2
      }
      let colorList = []
      picArray = []
      return this.passTypeCountDay(passTimeType).then(data => {
        if (data !== null && Array.isArray(data) && data.length > 0) {
          this.main2Show = false
          let echartDate = data.reduce((arr, d) => {
            arr.push({name: passType[d.passType], value: d.passCount})
            colorList.push(passTypeColor[d.passType])
            picArray.push(picArrays[d.passType])
            return arr
          }, [])
          this.passTypeCountDayEcharts(echartDate, colorList)
        } else {
          let myChart = echarts.init(this.$refs.main2)
          myChart.clear()
          this.main2Show = true
        }
      })
    },

    /**
       * @Description:获取人流量分布数据
       * @param {Object} {startTime:开始时间，endTime：结束时间}
       * @return null
       */
    doorTraDisByDirection ({startTime, endTime}) {
      if (!this.selectedProjectId) {
        return false
      }
      this.doorTraDisLoading = true
      return this.$https.get('passrecord/doorTraDisByDirection', {
        projectId: this.selectedProjectId,
        startTime,
        endTime
      }, false).then(({code, data, msg}) => {
        this.doorTraDisLoading = false
        if (code === '0') {
          return data
        } else {
          this.$message({
            type: 'error',
            message: msg,
            showClose: true
          })
        }
      }, () => {
        this.doorTraDisLoading = true
      })
    },
    /**
       * @Description:告警列表数据获取
       * @param null
       * @return null
       */
    async getSearchList () {
      if (!this.selectedProjectId) {
        return false
      }
      const data = await this.$https.get('console/alarmDetails', {projectId: this.selectedProjectId, count: 6}, false)
      this.tableData = data.data
    },

    /**
       * @Description:获取本月告警概况数据
       * @param {Object} {alarmStartTime:开始时间，alarmEndTime：结束时间}
       * @return null
       */
    countAlarmLevel (passTimeType) {
      if (!this.selectedProjectId) {
        return false
      }
      this.countAlarmLoading = true
      return this.$https.post('console/countAlarmSurvey', {
        projectId: this.selectedProjectId,
        passTimeType: passTimeType
      }, null, false).then(({code, data, msg}) => {
        this.countAlarmLoading = false
        if (code === '0') {
          return data
        } else {
          this.$message({
            type: 'error',
            message: msg,
            showClose: true
          })
        }
      }, () => {
        this.countAlarmLoading = false
      })
    },
    /**
       * @Description:本月告警概况echart渲染
       * @param {Object} {highCount：高告警数，middleCount：中告警数，lowCount：低告警数}
       * @return null
       */
    countAlarmLevelEcharts (data) {
      this.tipName = ''
      // this.countAlarm = true
      data.alarmNumber = data.alarmNumber !== null ? data.alarmNumber : 0
      data.highAlarm = data.highAlarm !== null ? data.highAlarm : 0
      data.middleAlarm = data.middleAlarm !== null ? data.middleAlarm : 0
      data.lowestAlarm = data.lowestAlarm !== null ? data.lowestAlarm : 0
      data.resolvedHigh = data.resolvedHigh !== null ? data.resolvedHigh : 0
      data.resolvedMiddle = data.resolvedMiddle !== null ? data.resolvedMiddle : 0
      data.resolvedLowest = data.resolvedLowest !== null ? data.resolvedLowest : 0
      this.countAlarmSurveyList = data
      // const [highCount, middleCount, lowCount, total] = [data.highAlarm, data.middleAlarm, data.lowestAlarm, data.highAlarm + data.middleAlarm + data.lowestAlarm]
      const [resolvedHigh, highCount] = [data.resolvedHigh, data.highAlarm]
      const [resolvedMiddle, middleCount] = [data.resolvedMiddle, data.middleAlarm]
      const [resolvedLowest, lowCount] = [data.resolvedLowest, data.lowestAlarm]
      // const total = highCount + middleCount + lowCount
      if (this.AlarmSurveyIndex === 2) {
        this.tipName = '昨日告警'
      } else if (this.AlarmSurveyIndex === 3) {
        this.tipName = '本周告警'
      } else if (this.AlarmSurveyIndex === 4) {
        this.tipName = '本月告警'
      } else {
        // sonar规则校验语法必须else
      }
      let option4 = {
        tooltip: {
          trigger: 'item',
          formatter: tipFormatter
        },
        series: [
          {
            name: this.tipName + '（高）',
            type: 'pie',
            radius: ['57%', '70%'],
            center: ['40%', '60%'],
            color: ['#FF7369', '#F5F7F9'],
            label: {
              show: true,
              position: 'center',
              // 在文本中，可以对部分文本采用 rich 中定义样式。
              // 这里需要在文本中使用标记符号：
              // `{styleName|text content text content}` 标记样式名。
              // 注意，换行仍是使用 '\n'。
              // formatter: [`{a|\n${highCount}}{c|/${total}\n}{b|\n高}`].join('\n'),
              formatter: [`{a|\n${resolvedHigh}}{c|/${highCount}\n}{b|\n高}`].join('\n'),
              // 这里是文本块的样式设置：
              color: '#333',
              padding: [3, 10, 10, 5],
              lineHeight: 20,

              // rich 里是文本片段的样式设置：
              rich: {
                a: {
                  color: '#ea6a6a',
                  fontSize: 20
                },
                c: {
                  color: '#454545',
                  fontSize: 20
                },
                b: {
                  color: '#454545',
                  fontSize: 14
                }
              }
            },
            emphasis: {},
            labelLine: {
              show: false
            },
            data: [
              {value: resolvedHigh, name: '高告警'},
              {value: highCount - resolvedHigh, name: '其余告警'}
              // {value: total - highCount, name: '其余告警'}
            ]
          }
        ]
      }
      this.$nextTick(() => {
        echarts.init(this.$refs.main4).setOption(option4)
      })
      let option5 = {}
      if (resolvedMiddle !== 0) {
        option5.tooltip = {
          trigger: 'item',
          formatter: tipFormatter
        }
      }
      option5 = {
        // tooltip: {
        //   trigger: 'item',
        //   formatter: tipFormatter
        // },
        series: [
          {
            name: this.tipName + '（中）',
            type: 'pie',
            radius: ['57%', '70%'],
            center: ['40%', '60%'],
            color: ['#F3C545', '#F5F7F9'],
            label: {
              show: true,
              position: 'center',
              // 在文本中，可以对部分文本采用 rich 中定义样式。
              // 这里需要在文本中使用标记符号：
              // `{styleName|text content text content}` 标记样式名。
              // 注意，换行仍是使用 '\n'。
              // formatter: [`{a|\n${middleCount}}{c|/${total}\n}{b|\n中}`].join('\n'),
              formatter: [`{a|\n${resolvedMiddle}}{c|/${middleCount}\n}{b|\n中}`].join('\n'),
              // 这里是文本块的样式设置：
              color: '#333',
              padding: [3, 10, 10, 5],
              lineHeight: 20,

              // rich 里是文本片段的样式设置：
              rich: {
                a: {
                  color: '#ffb726',
                  fontSize: 20
                },
                c: {
                  color: '#454545',
                  fontSize: 20
                },
                b: {
                  color: '#454545',
                  fontSize: 14
                }
              }
            },
            emphasis: {},
            labelLine: {
              show: false
            },
            data: [
              {value: resolvedMiddle, name: '中告警'},
              {value: resolvedMiddle !== 0 ? middleCount - resolvedMiddle : 1, name: '其余告警'}
              // {value: total - middleCount, name: '其余告警'}
            ]
          }
        ]
      }
      this.$nextTick(() => {
        echarts.init(this.$refs.main5).setOption(option5)
      })
      let option6 = {}
      if (lowCount !== 0) {
        option6.tooltip = {
          trigger: 'item',
          formatter: tipFormatter
        }
      }
      option6 = {
        series: [
          {
            name: this.tipName + '（消息）',
            type: 'pie',
            radius: ['57%', '70%'],
            center: ['40%', '60%'],
            color: ['#30BEAC', '#F5F7F9'],
            label: {
              show: true,
              position: 'center',
              // 在文本中，可以对部分文本采用 rich 中定义样式。
              // 这里需要在文本中使用标记符号：
              // `{styleName|text content text content}` 标记样式名。
              // 注意，换行仍是使用 '\n'。
              // formatter: [`{a|\n${}}{c|/${total}\n}{b|\n消息}`].join('\n'),
              formatter: [`{a|\n${resolvedLowest}}{c|/${lowCount}\n}{b|\n消息}`].join('\n'),
              // 这里是文本块的样式设置：
              color: '#333',
              padding: [3, 10, 10, 5],
              lineHeight: 20,

              // rich 里是文本片段的样式设置：
              rich: {
                a: {
                  color: '#50ca98',
                  fontSize: 20
                },
                c: {
                  color: '#454545',
                  fontSize: 20
                },
                b: {
                  color: '#454545',
                  fontSize: 14
                }
              }
            },
            emphasis: {},
            labelLine: {
              show: false
            },
            data: [
              {value: resolvedLowest, name: '消息'},
              {value: lowCount !== 0 ? lowCount - resolvedLowest : 1, name: '其余告警'}
            ]
          }
        ]
      }
      this.$nextTick(() => {
        echarts.init(this.$refs.main6).setOption(option6)
      })
    },
    /**
       * @Description:本月告警概况
       * @param null
       * @return null
       */
    getCountAlarmLevel (passTimeType) {
      if (typeof passTimeType === 'undefined') {
        passTimeType = 2
      }
      return this.countAlarmLevel(passTimeType).then(data => {
        if (data) {
          this.countAlarmLevelEcharts(data)
        } else {
          this.countAlarmSurveyList.alarmNumber = 0
        }
      })
    },
    /**
       * @Description:获取人员概况数据
       * @param null
       * @return null
       */
    async getNoPassEmpNum (passTimeType) {
      if (!this.selectedProjectId) {
        return false
      }
      if (typeof passTimeType === 'undefined') {
        passTimeType = 2
      }
      const result = await this.$https.post('console/personnelProfile', {
        projectId: this.selectedProjectId,
        passTimeType: passTimeType
      }, false)
      let data = result.data
      if (data !== null) {
        this.main3Show = false
        if (data.landlord === 0 && data.tenant === 0 && data.property === 0 && data.visitor === 0) {
          this.main3Show = true
        } else {
          this.main3Show = false
        }
        let echartDate = [
          {name: '业主人数', value: data.landlord},
          {name: '租客人数', value: data.tenant},
          {name: '物业人数', value: data.property},
          {name: '访客人数', value: data.visitor}
        ]
        // let echartDate = [
        //   {name: '业主人数', value: 800},
        //   {name: '租客人数', value: 200},
        //   {name: '物业人数', value: 13},
        //   {name: '访客人数', value: 50}
        // ]
        let personnelColor = ['#FAB28C', '#A8F28A', '#85A4E5', '#FAD46C']
        this.projectFaceEcharts(echartDate, personnelColor)
        this.personInit(data)
      } else {
        echarts.init(this.$refs.main3).clear()
        this.main3Show = true
      }
    },
    personInit (data) {
      let xAxisData = [data.faceRegistrationNumber]
      let data1 = [data.faceRegistrationNumber]
      let data2 = [data.faceRegistrationNumber - data.authorizedCardsNumber]
      let data3 = [data.faceRegistrationNumber]
      this.faceRegistration = {
        faceRegistrationNumber: data.faceRegistrationNumber,
        faceRegistrationRate: data.faceRegistrationRate,
        authorizedCardsNumber: data.authorizedCardsNumber,
        authorizedCardsRate: data.authorizedCardsRate
      }
      // let xAxisData = [800]
      // let data1 = [500]
      // let data2 = [300]
      // let data3 = [800]
      // this.faceRegistration = {
      //   faceRegistrationNumber: 500,
      //   faceRegistrationRate: '20%',
      //   authorizedCardsNumber: 800,
      //   authorizedCardsRate: '100%'
      // }
      let option = {
        // tooltip: {},
        color: ['#4ca6ff', '#e1e8f2', '#65d0a5'],
        xAxis: {
          data: xAxisData,
          axisLine: { show: false },
          axisLabel: { show: false },
          splitLine: { show: false },
          splitArea: { show: false }
        },
        yAxis: {
          axisLine: { show: false },
          axisLabel: { show: false },
          splitLine: { show: false },
          splitArea: { show: false },
          axisTick: {
            show: false
          }
        },
        grid: {
          bottom: 20,
          left: 0,
          right: 0,
          top: 70
        },
        series: [
          {
            name: '卡授权数',
            type: 'bar',
            stack: 'one',
            data: data1,
            barWidth: 18, // 柱图宽度
            barGap: '50%' // 柱图间距
          },
          {
            name: '',
            type: 'bar',
            stack: 'one',
            data: data2,
            barWidth: 18, // 柱图宽度
            barGap: '50%' // 柱图间距
          },
          {
            name: '人脸注册数',
            type: 'bar',
            stack: 'two',
            data: data3,
            barWidth: 18, // 柱图宽度
            barGap: '50%' // 柱图间距
          }
        ]
      }
      let myChart = echarts.init(this.$refs.main9)
      myChart.setOption(option)
    },
    /**
   * @Description:注册人脸渲染echarts
   * @param name {number}
   * @return null
   */
    projectFaceEcharts (data, coloList) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].value > 0) {
          data[i].label = {
            show: true,
            alignTo: 'edge',
            position: 'outer',
            // minMargin: 40,
            // edgeDistance: 0,
            margin: '10%',
            lineHeight: 12,
            formatter: '{name|{c}人}\n{time|{b}}',
            rich: {
              name: {
                fontSize: 14
              },
              time: {
                fontSize: 12,
                color: '#666666'
              }
            }
          }
          data[i].labelLine = {
            show: true
            // length: 25,
            // length2: 70
            // maxSurfaceAngle: 90
          }
        } else {
          data[i].label = {
            show: false
          }
          data[i].labelLine = {
            show: false
          }
        }
      }
      let option = {
        // itemStyle: {
        //   borderWidth: 2,
        //   borderColor: '#fff'
        // },
        title: {
          text: '  业主/访客/租客/物业人员人数',
          lineHeight: 10,
          padding: 20 // 标题内边距,
        },
        tooltip: {
          trigger: 'item',
          formatter: tipFormatter
        },
        series: [
          {
            // borderWidth: 2,
            // borderColor: '#fff',
            // ...option,
            name: '人员概况',
            type: 'pie',
            radius: ['65%', '50%'],
            center: ['50%', '68%'],
            color: coloList,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 1
            },
            labelLayout: function (params) {
              let myChart = echarts.init(this.$refs.main3)
              var isLeft = params.labelRect.x < myChart.getWidth() / 2
              var points = params.labelLinePoints
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width
              return {
                labelLinePoints: points
              }
            },
            emphasis: {},
            data: data
          }
        ]
      }
      if (data.length === 1) {
        option.itemStyle.borderWidth = 0
      }
      this.$nextTick(() => {
        echarts.init(this.$refs.main3).setOption(option)
      })
    },
    /**
       * @Description:在线设备和人员概况
       * @param null
       * @return null
       */
    deviceOnline () {
      let _self = this
      this.deviceOnlineLoading = true
      return this.getDeviceOnline().then(res => {
        _self.mainShow1 = true
        if (res.data) {
          _self.mainShow1 = false
          _self.deviceOnlineLoading = false
          res.data.averageOfflineTimes = 0
          res.data.averageOfflineTotal = '00:00:00'
          res.data.latestVersionNumber = 0
          _self.deviceOnlines = res.data
        }
      }, () => {
        this.deviceOnlineLoading = false
      })
    }
  },
  destroyed () {
    clearInterval(interval)
  }
}
</script>
<style lang="less" scoped>
  .home {
    min-width: 1818px;
    // ::v-deep .el-table__body{
    //   height: 100%;
    // }
    // /deep/ .el-table__body{
    //   height: 100%;
    // }
    div.col-padding {
      padding: 0;
    }

    .tab {
      color: #BFBFC1;
      font-size: 12px;
      padding: 3px 12px;
      font-weight: 500;
      /*border-radius:9px;*/
      cursor: pointer;
      background: rgba(248, 248, 248, 1);
      border-radius: 16px;
      position: relative;
      border: 1px solid rgba(238, 238, 238, 1);
      z-index: 1;
    }

    .more {
      color: #454545;
      float: right;
      font-size: 12px;
      cursor: pointer;
    }

    .tab.invalidLeft {
      padding-right: 24px;
    }

    .tab.invalidRight {
      padding-left: 24px;
      margin-left: -22px;
      z-index: 1
    }

    .tab.invalidMiddle {
      margin-left: -19px;
      margin-top: -1px;
      z-index: 8;
      padding-left: 24px;
      border-left: none;
      border-right: none;
      border-radius:0;
    }

    .tab.activationRight {
      padding-right: 24px;
      padding-left: 12px;
    }

    .tab.activation {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.03), 0px 1px 2px 0px rgba(0, 0, 0, 0.12);
      z-index: 9;
      padding-right: 12px;
      padding-left: 12px;
      color: #454545;
      border-radius:16px;
    }

    .header {
      padding: 20px;
      color: #666666;
      font-size: 14px;
      font-weight: bold;
      clear: both;
      .headRow{
        float: left;
      }
      .title{
        font-size: 16px;
        text-align: left;
        width: 90px;
        line-height: 0px;
        margin-top: 10px;
        box-sizing: border-box;
        border-bottom: 10px solid #c9dbf0;
        border-radius: 2px;
      }
      .title1{
        font-size: 16px;
        text-align: left;
        width: 120px;
        line-height: 0px;
        margin-top: 10px;
        box-sizing: border-box;
        border-bottom: 10px solid #c9dbf0;
        border-radius: 2px;
      }
      .total{
        font-size: 14px;
        margin-left: 20px;
        width: calc(50% - 110px)
        // text-align: center;
      }
      .tabs{
        font-size: 14px;
        text-align: right;
        width: 50%;
        .active{
          color: #5c8ec7;
          width: 26px;
          height: 4px;
          border-bottom: 3px solid #5c8ec7;
          border-radius: 2px;
        }
        >label{
          margin-right: 20px;
        }
      }
      .inputTab{
        width: calc(100% - 100px);
        text-align: right;
      }
    }

    .table {
      width: 100%;

      /deep/ .el-table th {
        background: #FFFFFF;
        color: #454545;
        font-weight: inherit;
        font-size: 12px;
        border-bottom: 1px solid #ebeef5;
      }
    }

    div.col-margin {
      margin: 10px 0;
    }
    .col4 {
      width: 100%;
      height: 287px;
      float: left;
      padding: 0 10px;
    }
    .col2 {
      width: 50%;
      height: 287px;
      float: left;
      padding: 0 10px;
    }
    .personnelContent{
      height: 220px;
      width: 45%;
      float: left;
      overflow: hidden;
      position: relative;
      .title{
        font-family: MicrosoftYaHei-Bold;
        font-size: 18px;
        font-weight: 600;
        font-stretch: normal;
        line-height: 26px;
        letter-spacing: 0px;
        color: #000000;
        position: absolute;
        top: 14px;
      }
      .echartDecs{
        width: 100px;
        height: 100%;
        float: left;
        margin-top: 80px;
        padding-left: 30px;
        .item1{
          margin-bottom: 20px;
          .label1{
            font-size: 14px;
            font-weight: normal;
            font-family: MicrosoftYaHei-Bold;
          }
          .label2{
            color: #666666;
            font-size: 12px;
            font-family: MicrosoftYaHei-Bold;
          }
        }
        .item2{
          .label1{
            font-size: 14px;
            font-weight: normal;
            font-family: MicrosoftYaHei-Bold;
          }
          .label2{
            color: #666666;
            font-size: 12px;
            font-family: MicrosoftYaHei-Bold;
          }
        }
      }
    }
    .col2MinWidth {
      min-width: 600px;
    }

    .col1 {
      // width: 20%;
      // height: 70px;
      width: 140px;
      height: 140px;
      float: left;
      margin-right: 23px;
      // margin-left: 30px;
      padding-top: 35px;
      // padding: 0 10px;
      text-align: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      .number {
        font-size: 36px;
        // color: rgba(133, 183, 237, 1);
      }

      .highlight  {
        color: rgba(104, 208, 194, 1);
      }
    }
    .equipment1{
      background: url('~@/assets/images/home/equipmentTotal.png') no-repeat center;
      margin-left: 50px;
      color: #52a9ff;
    }
    .equipment2{
      background: url('~@/assets/images/home/checkCount.png') no-repeat center;
      color: #ffb726;
    }
    .equipment3{
      background: url('~@/assets/images/home/onlineCount.png') no-repeat center;
      color: #50ca98;
    }
    .equipment4{
      background: url('~@/assets/images/home/downlineCount.png') no-repeat center;
      color: #ea6a6a;
    }
    .equipment5{
      background: url('~@/assets/images/home/onlineCount.png') no-repeat center;
      color: #50ca98;
    }
    .panel {
      background: #FFFFFF;
      width: 100%;
      height: 100%;
      border-radius: 6px;
      position: relative;
      .echartContent{
        height: 260px;
        width: 100%;
        clear: both;
        .echartDiv{
          width: 33%;
          height: 100%;
          float: left;
          position: relative;
          .echartPie{
            width: 100%;
            height: 100%;
          }
          .echartDec{
            position: absolute;
            right: 0;
            top: 45%;
            .item1{
              margin-top: -20px;
              .label1{
                color: #666666;
                font-size: 14px;
                font-weight: 600;
              }
              .label2{
                color: #666666;
                font-size: 12px;
              }
            }
            .item2{
              margin-top: 40px;
              .label1{
                color: #ea6a6a;
                font-size: 14px;
                font-weight: 600;
              }
              .label2{
                color: #ffb726;
                font-size: 14px;
                font-weight: 600;
              }
              .label3{
                color: #50ca98;
                font-size: 14px;
                font-weight: 600;
              }
              .label{
                color: #666666;
                font-size: 12px;
              }
            }
          }
        }
      }
    }

    .panel-1 {
      width: 330px;
      height: 287px;
      float: left;
      background: #FFFFFF;
      border-radius: 6px;
    }

    .date{
      position: absolute;
      top: 249px;
      width: 70%;
      text-align: center;
      color: rgba(60, 60, 67, 0.3);
      font-size: 12px;
    }
    .danger{
      color: #FF7369;
    }
    .warning{
      color: #EEB924;
    }
    .success{
      color: #30BEAC;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue